import React from 'react';
import './Blogs.css'
import blogImage from '../../img/Screenshot (272).png'
const Blogs = () => {
    return (
       <div>
            <div id="blogs" className="cardParent row">
            <h1 className=" blogs-title">My BLogs Website (Design Comming soon!)</h1>

            <div className="col-md-4"> 

            </div>
            <div  className="col-md-4 blogchild">
                <img src={blogImage} className="w-100" alt=""/>
                <button className=" btn btn-primary"><a className="text-light" target="_blank" href="https://shahinshah.medium.com/">Read My Blog</a></button>

            </div>
            <div  className="col-md-4">

            </div>

          
            

                  
            
        </div>

        <hr/>
       </div>
    );
};

export default Blogs;